module.exports = __webpack_public_path__ + "img/yb2.4dd9cc89.jpg";